import PropTypes from 'prop-types';
import React, { useState } from 'react';
import classNames from 'classnames';
import { isEmpty, memoize } from 'lodash';
import { path, pipe, prop, propOr, ifElse, pluck, sortWith, ascend } from 'ramda';
import { USER_TYPES } from '../../../../auth/constants';
import { t } from '../../../../../modules/infra/i18n';

import UserForm from '../Shared/userForm';
import { getInitialValuesFromUser } from '../../helpers/form';
import SimpleHeader from '../../../../main/headers/simpleHeader';

const getShopsFromUser = memoize(
  ifElse(
    path(['barbers', '0', 'shop']),
    pipe(prop('barbers'), pluck('shop')),
    pipe(
      propOr([], 'shops'),
      sortWith([ascend(path(['brand', 'shops', 'shopOrder']))])
    ),
  )
);

const EditUser = ({ user, shops, saveAndRedirect, onLogoutAllClick, onDeleteClick }) => {
  const [activeTab, setActiveTab] = useState('details');

  if (isEmpty(user)) {
    return null;
  }

  const initialValues = getInitialValuesFromUser(user);

  const isBarberUser = parseInt(initialValues.kind, 10) === USER_TYPES.barber;

  return (
    <div>
      <SimpleHeader heading={t('admin:users.edit.page_heading', { username: user.username }) || ''} />
      <div className="c-wrapper">
        <div className="o-flexbox">
          <div className="o-flexbox__item o-flexbox__item--flex-start u-1/1">
            <div className="u-width-710 u-margin-auto">
              {isBarberUser &&
              <div>
                <ul className="c-nav-tabs list-bare u-mb-">
                  <li>
                    <button
                      className={classNames('c-nav-tab', { 'is-active': activeTab === 'details' })}
                      onClick={() => setActiveTab('details')}
                    >
                      {t('admin:users.edit.user_details_tab')}
                    </button>
                  </li>
                </ul>
              </div>
              }
              {activeTab === 'details' &&
              <UserForm
                saveUpdatedUser={saveAndRedirect}
                initialValues={initialValues}
                shops={shops}
                onLogoutAllClick={onLogoutAllClick}
                onDeleteClick={onDeleteClick}
                edit
                userShops={getShopsFromUser(user)}
              />
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

EditUser.propTypes = {
  saveAndRedirect: PropTypes.func.isRequired,
  onLogoutAllClick: PropTypes.func.isRequired,
  onDeleteClick: PropTypes.func.isRequired,
  user: PropTypes.object,
  shops: PropTypes.array.isRequired,
};

EditUser.defaultProps = {
  user: {},
};

export default EditUser;
